/* MUI */
import { Box, TableCell } from '@mui/material';

/*  Shared  */
import { DateFormat } from 'application/Shared/Components/Core';
import { ManagedTable } from 'application/Shared/Components/Table';

/*  Objects  */
import { User, UserEmail, UserFromContext } from 'objects/User';

/* React */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const headers = (t) => [
    {
        align: 'left',
        field: 'user',
        renderHeader: <strong>{t('Reports.Contracts.user')}</strong>,
        sortable: true,
        sortableFieldType: 'string',
        sortableKey: 'name',
        width: '25%'
    },
    {
        align: 'left',
        field: 'email',
        renderHeader: <strong>{t('Reports.Contracts.email')}</strong>,
        sortable: true,
        sortableFieldType: 'string',
        sortableKey: 'email',
        width: '25%'
    },
    {
        align: 'left',
        field: 'firstUsed',
        renderHeader: <strong>{t('Reports.Contracts.firstDetected')}</strong>,
        sortable: true,
        sortableFieldType: 'date',
        sortableKey: 'userAppActivity.firstUsed',
        width: '25%'
    },
    {
        align: 'left',
        field: 'lasttUsed',
        renderHeader: <strong>{t('Reports.Contracts.lastUsed')}</strong>,
        sortable: true,
        sortableFieldType: 'date',
        sortableKey: 'userAppActivity.lastUsed',
        width: '25%'
    }
];

export const UserDetailsContractUsersTable = ({ users }) => {
    const { t } = useTranslation();

    const tableHeaders = useMemo(() => headers(t), [t]);

    return (
        <ManagedTable
            headers={tableHeaders}
            renderBody={(row) => (
                <User data={row}>
                    <TableCell>
                        <UserFromContext link />
                    </TableCell>
                    <TableCell>
                        <UserEmail />
                    </TableCell>
                    <TableCell>
                        <DateFormat
                            date={row.userAppActivity?.firstUsed}
                            noTimeString
                            abbreviatedMonthDate
                        />
                    </TableCell>
                    <TableCell>
                        <Box display="flex" alignItems="center">
                            <DateFormat
                                date={
                                    row.userAppActivity?.lastUsed ||
                                    row.userAppActivity?.firstUsed
                                }
                                noTimeString
                                abbreviatedMonthDate
                                alertInactivity={30}
                                tooltipText={t(
                                    'Reports.Contracts.lastUsage30DaysAgo'
                                )}
                            />
                        </Box>
                    </TableCell>
                </User>
            )}
            renderBodyKey="id"
            rows={users}
            rowsPerPage={-1}
            sortDirection="ASC"
            sortFieldType="date"
            sortKey="userAppActivity.lastUsed"
        />
    );
};
